import { useTranslation } from '@numistic/i18n'
import { cn } from '@numistic/ui'

export type TextLanguage = 'ru' | 'original'

/**
 * Переключатель «Русский / Оригинал» для текстов, переведённых из Numista. Значения с
 * переводом — в values, оригиналы — в originals; withLanguage собирает то, что показать.
 */
export function LanguageToggle({
  value,
  onChange,
  className,
}: {
  value: TextLanguage
  onChange: (value: TextLanguage) => void
  className?: string
}) {
  const { t } = useTranslation()
  return (
    <div
      role="group"
      aria-label={t('translation.language')}
      className={cn('inline-flex rounded-md border bg-muted/40 p-0.5 text-xs', className)}
    >
      {(['ru', 'original'] as const).map((lang) => (
        <button
          key={lang}
          type="button"
          aria-pressed={value === lang}
          onClick={() => onChange(lang)}
          className="rounded px-2.5 py-1 text-muted-foreground transition-colors hover:text-foreground aria-pressed:bg-card aria-pressed:text-foreground aria-pressed:shadow-sm"
        >
          {t(lang === 'ru' ? 'translation.russian' : 'translation.original')}
        </button>
      ))}
    </div>
  )
}

export function withLanguage(
  values: Record<string, unknown>,
  originals: Record<string, string>,
  language: TextLanguage,
): Record<string, unknown> {
  return language === 'original' ? { ...values, ...originals } : values
}
